import React, { useState } from 'react';
import Webcam from 'react-webcam';
import axios from 'axios';
import { SEND_OTP_API, VERIFY_OTP_API } from '../../utils/api';
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";


function BasicInfoTab({
  form,
  setForm,
  handleChange,
  webcamRef,
  photo,
  setPhoto,
  isWebcamReady,
  setIsWebcamReady,
  wabaActive
}) {
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpVerified, setOtpVerified] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [removingBg, setRemovingBg] = useState(false);


  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const company_id = decoded.customer_id || decoded.company_id || 0;

  const isValidMobile = (mobile) => /^[0-9]{10}$/.test(mobile);

  const capturePhoto = () => {
    try {
      if (webcamRef?.current) {
        const image = webcamRef.current.getScreenshot();
        if (image) {
          setPhoto(image);
        } else {
          alert('Could not capture photo. Webcam might not be ready.');
        }
      } else {
        alert('Webcam is not available.');
      }
    } catch (err) {
      console.error('Capture error:', err);
      alert('An error occurred while capturing the photo.');
    }
  };

  const resetPhoto = () => setPhoto(null);





  const removeBackground = async () => {
    if (!photo) return alert("Capture a photo first.");
    setRemovingBg(true); // 🔁 Start loading

    const image = new Image();
    image.src = photo;

    image.onload = async () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);

      const segmentation = new SelfieSegmentation({
        locateFile: (file) =>
          `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
      });

      segmentation.setOptions({ modelSelection: 1 });

      segmentation.onResults((results) => {
        const outputCanvas = document.createElement("canvas");
        outputCanvas.width = canvas.width;
        outputCanvas.height = canvas.height;
        const outputCtx = outputCanvas.getContext("2d");

        outputCtx.clearRect(0, 0, outputCanvas.width, outputCanvas.height);
        const mask = results.segmentationMask;
        outputCtx.drawImage(mask, 0, 0);
        const imageData = outputCtx.getImageData(0, 0, outputCanvas.width, outputCanvas.height);

        for (let i = 0; i < imageData.data.length; i += 4) {
          if (imageData.data[i + 3] < 128) {
            imageData.data[i + 3] = 0;
          }
        }

        outputCtx.putImageData(imageData, 0, 0);
        outputCtx.globalCompositeOperation = "source-in";
        outputCtx.drawImage(image, 0, 0);

        const finalImage = outputCanvas.toDataURL("image/png");
        setPhoto(finalImage);
        setRemovingBg(false); // ✅ Done loading
      });

      await segmentation.send({ image });
    };
  };

  const sendOtp = async () => {
    if (!isValidMobile(form.mobile)) return alert('Invalid mobile number');
    setSendingOtp(true);
    try {
      const res = await axios.post(SEND_OTP_API, {
        mobile: form.mobile,
        company_id,
        token,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        alert('OTP sent successfully');
        setOtpSent(true);
      } else {
        alert(res.data.message || 'Failed to send OTP');
      }
    } catch (err) {
      alert('Error sending OTP');
      console.error(err);
    } finally {
      setSendingOtp(false);
    }
  };

  const verifyOtp = async () => {
    if (otp.trim().length === 0) return;
    setVerifyingOtp(true);
    try {
      const res = await axios.post(VERIFY_OTP_API, {
        mobile: form.mobile,
        otp,
        company_id,
        token,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        alert(res.data.message);
        setOtpVerified(true);

        if (res.data.exists && res.data.visitor) {
          const v = res.data.visitor;
          setForm(prev => ({
            ...prev,
            name: v.name || '',
            sex: v.sex || '',
            team_members: '',
            company: v.company || '',
            companyAddress: v.company_address || '',
            pincode: v.pincode || '',
            state: v.state || '',
            district: v.district || '',
            city: v.city || '',
            gst: v.gst || '',
            idDocument: v.id_document || '',
            idNumber: v.id_number || '',
            birthDate: v.birth_date || '',
          }));
        }
      } else {
        alert(res.data.message || 'Invalid OTP');
      }
    } catch (err) {
      alert('Error verifying OTP');
      console.error(err);
    } finally {
      setVerifyingOtp(false);
    }
  };



  const fetchVisitorDataWithoutOtp = async (mobile) => {
  try {
    const res = await axios.post(VERIFY_OTP_API, {
      mobile,
      otp: '',
      company_id,
      token,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (res.data.success && res.data.exists && res.data.visitor) {
      const v = res.data.visitor;
      setForm(prev => ({
        ...prev,
        name: v.name || '',
        sex: v.sex || '',
        team_members: '',
        company: v.company || '',
        companyAddress: v.company_address || '',
        pincode: v.pincode || '',
        state: v.state || '',
        district: v.district || '',
        city: v.city || '',
        gst: v.gst || '',
        idDocument: v.id_document || '',
        idNumber: v.id_number || '',
        birthDate: v.birth_date || '',
      }));
    }
  } catch (err) {
    console.error('Auto-fetch failed:', err);
  }
};


  const shouldShowFormFields = !wabaActive || otpVerified;

  return (
    <div className="row">
      {/* Left Section */}
      <div className="col-md-8">
        <div className="mb-3">
          <label className="form-label">Mobile Number</label>
          <input
            className="form-control"
            name="mobile"
            value={form.mobile}
           onChange={(e) => {
  const mobile = e.target.value;
  handleChange(e);
  setOtpSent(false);
  setOtpVerified(false);
  setOtp('');
  
  // 👇 If WABA is NOT active and number is valid, auto-fetch visitor data
  if (!wabaActive && /^[0-9]{10}$/.test(mobile)) {
    fetchVisitorDataWithoutOtp(mobile);
  }
}}

            required
            maxLength={10}
            pattern="[0-9]{10}"
            placeholder="Enter mobile number, 10 Digits only"
            autoComplete="off"
          />
        </div>

        {/* Show Send OTP Button */}
        {wabaActive && isValidMobile(form.mobile) && !otpSent && (
          <button
            className="btn btn-sm btn-outline-primary mb-3"
            onClick={sendOtp}
            disabled={sendingOtp}
          >
            {sendingOtp ? 'Sending...' : 'Send OTP'}
          </button>
        )}

        {/* Show OTP input */}
        {wabaActive && otpSent && !otpVerified && (
          <div className="mb-3">
            <label className="form-label">Enter OTP</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                placeholder="Enter OTP"
              />
              <button
                className="btn btn-outline-success"
                onClick={verifyOtp}
                disabled={verifyingOtp}
              >
                {verifyingOtp ? 'Verifying...' : 'Verify OTP'}
              </button>
            </div>
          </div>
        )}

        {/* Input fields shown directly if WABA inactive OR OTP verified */}
        {shouldShowFormFields && (
          <>
            <div className="mb-3">
              <label className="form-label">Visitor Name</label>
              <input
                className="form-control"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Enter visitor name"
                autoComplete="off"
              />
            </div>

            <div className="mb-3 row">
              <div className="col-md-6">
                <label className="form-label">Sex</label>
                <select
                  className="form-select"
                  name="sex"
                  value={form.sex}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Team Members</label>
                <select
                  className="form-select"
                  name="team_members"
                  value={form.team_members || '0'}
                  onChange={handleChange}
                >
                  <option value="0">0</option>
                  {[...Array(10).keys()].slice(1).map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                  <option value="10+">10+</option>
                </select>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Right Section - Webcam */}
      <div className="col-md-4">
        <div className="text-center mb-3">
          <label className="form-label d-block">Capture Photo</label>
          {photo ? (
            <>
              <img
                src={photo}
                alt="Captured"
                className="img-thumbnail mb-2"
                style={{ width: '150px', height: '150px', objectFit: 'cover' }}
              />

              <button
                type="button"
                className="btn btn-warning btn-sm mb-2 w-100"
                onClick={removeBackground}
                disabled={removingBg}
              >
                {removingBg ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  '🎯 Remove Background'
                )}
              </button>

            </>

          ) : (
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              width={150}
              height={150}
              onUserMedia={() => setIsWebcamReady(true)}
              videoConstraints={{ width: 150, height: 150, facingMode: 'user' }}
              className="mb-2"
            />
          )}
          <button
            type="button"
            className="btn btn-outline-primary btn-sm w-100"
            onClick={photo ? resetPhoto : capturePhoto}
          >
            {photo ? '📸 Retake Photo' : '📷 Capture Photo'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BasicInfoTab;
